var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrusted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13683_28927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26667 0.185112C7.74832 0.0636073 8.25261 0.0636073 8.73427 0.185112L13.4319 1.37014C14.8681 1.73246 15.825 3.08884 15.6845 4.56344L15.0753 10.9599C14.9833 11.9262 14.4295 12.7882 13.5889 13.2735L9.50047 15.634C8.57227 16.1699 7.42867 16.1699 6.50047 15.634L2.41208 13.2735C1.57147 12.7882 1.01762 11.9262 0.925589 10.9599L0.316403 4.56344C0.175965 3.08884 1.13281 1.73246 2.56909 1.37014L7.26667 0.185112Z",
    fill: "#00BFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8L6.66667 10.5L12 5.5",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13683_28927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusted);
export default __webpack_public_path__ + "static/media/Trusted.871073da5ca65025d623d07d4aad1c81.svg";
export { ForwardRef as ReactComponent };